var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.authenticated)?_c('Navbar'):_vm._e(),_c('v-content',{staticClass:"grey lighten-3"},[_c('Notification'),_c('router-view')],1),(_vm.authenticated)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }